import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import Router from 'next/router'

import { withI18next } from '../../lib/withI18next'
import withMainLayout from '../Layouts'
import withAuthCheck from './withAuthCheck'
import { addToCart } from '../../reducers/cart'
import { logOut } from '../../reducers/user'
import { notify } from '../../lib/notification'

const mapStateToProps = state => {
  return {
    user: state.user.details,
    isAuthenticated: state.user.isAuthenticated,
    language: state.cookies.lang,
    cart: state.cart
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchAddToCart: subscription => dispatch(addToCart(subscription)),
  logOut: () => dispatch(logOut()),
  createNotification: opts => dispatch(notify(opts)),
})

export default compose(
  withI18next(['common']),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    addToCart: props => (...params) => {
      return props.dispatchAddToCart(...params)
        .then(() => {
          Router.push('/cart')
        })
        .catch(e => {
          props.createNotification({
            type: 'error',
            duration: 10000,
            message: props.t(e.message || 'server-error')
          })
        })
    }
  }),
  withMainLayout,
  withAuthCheck
)



// WEBPACK FOOTER //
// ./components/hoc/withInitialData.js